import LoginSelect from './login-select';

export default LoginSelect;
